import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "./Layout/DashboardLayout";
import Overview from "./pages/Overview";
import Error_404 from "pages/Errors/Error_404";
import Error_500 from "pages/Errors/Errors_500";
import Error_401 from "pages/Errors/Error_401";
import IncidentForm from "./pages/Overview/component/IncidentForm";


import IncidentView from "./pages/IncidentInitiation/component/IncidentView";
import IncidentInitiation from "./pages/IncidentInitiation";
import IncidentAddForm from "./pages/IncidentInitiation/component/IncidentAdd";
import IncidentUpdateForm from "./pages/IncidentInitiation/component/IncidentUpdate";
import AIPrompt from "pages/AIPrompt";

const Commitee = lazy(() => import("pages/Commitee"));
const Scopes = lazy(() => import("pages/Scopes"));

const routes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        index: true, // Default child route
        element: <Navigate to="incidentInitiation" />,
      },
      
      {
        path: "scopes",
        element: <Scopes />,
      },
      
      {
        path: "commitee",
        element: <Commitee />,
      },

      {
        path: "scopeIncident",
        element: <Overview />,
      },
      {
        path: "scopeIncident/add",
        element: <IncidentForm />,
      },
      {
        path: "scopeIncident/edit",
        element: <IncidentForm />,
      },


      {
        path: "incidentForm",
        element: <Overview />,
      },
      {
        path: "incidentForm/add",
        element: <IncidentForm />,
      },
      {
        path: "incidentForm/edit",
        element: <IncidentForm />,
      },
      

      {
        path: "incidentInitiation",
        element: <IncidentInitiation />,
      },
      {
        path: "incidentInitiation/add",
        element: <IncidentAddForm />,
      },
      {
        path: "incidentInitiation/update",
        element: <IncidentUpdateForm />,
      },
      {
        path: "incidentInitiation/view",
        element: <IncidentView />,
      },

      {
        path: "ai-prompts",
        element: <AIPrompt/>
      },

      {
        path: "errors",
        children: [
          {
            path: "error-404",
            element: <Error_404 />,
          },
          {
            path: "error-401",
            element: <Error_401 />,
          },
        ],
      },
    ],
  },
];

export default routes;
